import TablePagination from "@mui/material/TablePagination";

export function RopTablePageSelector(props: {
  itemsAmount: number;
  rowsPerPage: number;
  page: number;
  setPage: (page: number) => void;
  setRowsPerPage: (rowsPerPage: number) => void;
}) {
  const {
    itemsAmount: usinasAmout,
    rowsPerPage,
    page,
    setPage,
    setRowsPerPage,
  } = props;
  return (
    <TablePagination
      rowsPerPageOptions={[10, 25, 100]}
      labelRowsPerPage="Itens por página"
      labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      showFirstButton
      showLastButton
      component="div"
      sx={{
        labelDisplayedRows: { backgroundColor: "black" },
        "& .MuiTablePagination-selectLabel": {
          margin: 0,
          display: { md: "block", xs: "none" },
        },
        "& .MuiTablePagination-displayedRows": {
          margin: 0,
        },
        "& .MuiInputBase-root": {
          display: { md: "block", xs: "none" },
        },
      }}
      count={usinasAmout}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={(_, page) => {
        setPage(page);
      }}
      onRowsPerPageChange={(e) => {
        setPage(0);
        setRowsPerPage(Number(e.target.value));
      }}
    />
  );
}
